import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e88533c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-ttr" }
const _hoisted_2 = { class: "nge-ttr-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Proofreading Test tries", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "nge-ttr-sub"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "nge-ttr-filters",
  role: "tablist"
}
const _hoisted_7 = ["aria-selected"]
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = {
  key: 0,
  class: "nge-ttr-how"
}
const _hoisted_10 = {
  key: 1,
  class: "nge-ttr-line"
}
const _hoisted_11 = { class: "nge-ttr-line-name" }
const _hoisted_12 = { class: "nge-ttr-meta" }
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = {
  key: 2,
  class: "nge-ttr-warn"
}
const _hoisted_15 = {
  key: 3,
  class: "nge-ttr-err",
  role: "alert"
}
const _hoisted_16 = {
  key: 4,
  class: "nge-ttr-how"
}
const _hoisted_17 = {
  key: 5,
  class: "nge-ttr-how"
}
const _hoisted_18 = ["aria-expanded", "onClick"]
const _hoisted_19 = { class: "nge-ttr-name" }
const _hoisted_20 = { class: "nge-ttr-meta" }
const _hoisted_21 = { class: "nge-ttr-status" }
const _hoisted_22 = { class: "nge-ttr-tally" }
const _hoisted_23 = {
  key: 0,
  class: "nge-ttr-body"
}
const _hoisted_24 = {
  key: 0,
  class: "nge-ttr-how"
}
const _hoisted_25 = {
  key: 1,
  class: "nge-ttr-err",
  role: "alert"
}
const _hoisted_26 = {
  key: 0,
  class: "nge-ttr-note"
}
const _hoisted_27 = {
  key: 1,
  class: "nge-ttr-note"
}
const _hoisted_28 = {
  key: 0,
  class: "nge-ttr-why"
}
const _hoisted_29 = {
  key: 0,
  class: "nge-ttr-worth"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "nge-ttr-ends"
}
const _hoisted_32 = { class: "nge-ttr-acts" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "nge-ttr-why"
}
const _hoisted_35 = {
  key: 2,
  class: "nge-ttr-root",
  title: "Their cell's segment ID as they left it"
}
const _hoisted_36 = {
  key: 3,
  class: "nge-ttr-how"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      ($setup.data)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.plural($setup.scoredCount, 'scored try', 'scored tries')) + " · " + _toDisplayString($setup.passCount) + " passed", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        class: "nge-ttr-filter nge-ttr-refresh",
        disabled: $setup.loading,
        title: "Look for new tries",
        onClick: $setup.load
      }, "Refresh", 8 /* PROPS */, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["nge-ttr-filter", { 'nge-ttr-filter--on': $setup.filter === 'scored' }]),
          role: "tab",
          "aria-selected": $setup.filter === 'scored',
          onClick: _cache[0] || (_cache[0] = $event => ($setup.filter = 'scored'))
        }, "Scored", 10 /* CLASS, PROPS */, _hoisted_7),
        _createElementVNode("button", {
          class: _normalizeClass(["nge-ttr-filter", { 'nge-ttr-filter--on': $setup.filter === 'all' }]),
          role: "tab",
          "aria-selected": $setup.filter === 'all',
          onClick: _cache[1] || (_cache[1] = $event => ($setup.filter = 'all'))
        }, "All", 10 /* CLASS, PROPS */, _hoisted_8)
      ])
    ]),
    ($setup.data?.test && $setup.data.key)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _createTextVNode(" The test now: " + _toDisplayString($setup.plural($setup.data.key.mistakes, 'mistake')) + " to fix, " + _toDisplayString($setup.plural($setup.data.key.ends, 'branch end')) + " to mark, " + _toDisplayString($setup.plural($setup.data.key.protect, 'real branch tip', 'real branch tips')) + " not to cut off. A pass needs " + _toDisplayString($setup.data.test.pass_mark) + " percent of " + _toDisplayString($setup.n($setup.data.key.points)) + " points. ", 1 /* TEXT */),
          ($setup.data.test.holder)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("b", null, _toDisplayString($setup.data.test.holder), 1 /* TEXT */),
                _createTextVNode(" has the cell now"),
                ($setup.data.test.deadline_at)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(", until " + _toDisplayString($setup.when($setup.data.test.deadline_at)), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(".")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Nobody has the cell now.")
              ], 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.data?.line?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h3", null, "In line (" + _toDisplayString($setup.data.line.length) + ")", 1 /* TEXT */),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.line, (p) => {
              return (_openBlock(), _createElementBlock("li", {
                key: p.user_id
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(p.username || 'A player'), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode("joined " + _toDisplayString($setup.when(p.joined_at)), 1 /* TEXT */),
                  (p.called_at)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(", called: their turn until " + _toDisplayString($setup.turnUntil(p.called_at)), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  class: "nge-ttr-btn nge-ttr-btn--small",
                  disabled: $setup.removing === p.user_id,
                  onClick: $event => ($setup.takeOut(p.user_id))
                }, "Take out of the line", 8 /* PROPS */, _hoisted_13)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.data && !$setup.data.kept)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Players' cells are not being kept yet: run supabase-proofreading-test-tries.sql in Supabase."))
      : _createCommentVNode("v-if", true),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Loading…"))
      : ($setup.data && !$setup.tries.length && !$setup.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, "No tries here yet."))
        : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tries, (t) => {
      return (_openBlock(), _createElementBlock("article", {
        key: t.id,
        class: _normalizeClass(["nge-ttr-card", `nge-ttr-card--${$setup.chip(t)}`])
      }, [
        _createElementVNode("button", {
          class: "nge-ttr-head",
          "aria-expanded": $setup.openId === t.id,
          onClick: $event => ($setup.toggle(t))
        }, [
          _createElementVNode("span", _hoisted_19, _toDisplayString($setup.playerName(t)), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_20, [
            _createTextVNode(_toDisplayString($setup.when(t.started_at)), 1 /* TEXT */),
            ($setup.took(t))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · took " + _toDisplayString($setup.took(t)), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (t.timed_out)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" · time ran out")
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_21, [
            _createTextVNode(_toDisplayString($setup.outcomeWord(t)), 1 /* TEXT */),
            (t.percent != null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · " + _toDisplayString(t.percent) + "%", 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_22, _toDisplayString($setup.tally(t)), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_18),
        ($setup.openId === t.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              ($setup.busy === t.id)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Loading the try…"))
                : ($setup.detailError[t.id])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString($setup.detailError[t.id]), 1 /* TEXT */))
                  : ($setup.details[t.id])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (t.outcome === 'expired')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString($setup.playerName(t)) + " left without submitting, so this try has no score. What is below is the cell as they left it; the branch ends they marked never reached the server. ", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (t.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Server note: " + _toDisplayString(t.error), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PARTS, (part) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: part.key
                          }, [
                            ($setup.partsOf[t.id][part.key].length)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["nge-ttr-part", `nge-ttr-part--${part.key}`])
                                }, [
                                  _createElementVNode("h3", null, _toDisplayString(part.title) + " (" + _toDisplayString($setup.partsOf[t.id][part.key].length) + ")", 1 /* TEXT */),
                                  (part.why)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(part.why), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($setup.showAll[`${t.id}${part.key}`] ? $setup.partsOf[t.id][part.key] : $setup.partsOf[t.id][part.key].slice(0, $setup.FIRST)), (c, i) => {
                                      return (_openBlock(), _createElementBlock("li", { key: i }, [
                                        _createElementVNode("span", null, _toDisplayString(c.label), 1 /* TEXT */),
                                        (part.key !== 'damage')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString($setup.n(c.weight)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  ($setup.partsOf[t.id][part.key].length > $setup.FIRST)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "nge-ttr-more",
                                        onClick: $event => ($setup.showAll[`${t.id}${part.key}`] = !$setup.showAll[`${t.id}${part.key}`])
                                      }, _toDisplayString($setup.showAll[`${t.id}${part.key}`] ? 'Show fewer' : `Show all ${$setup.partsOf[t.id][part.key].length}`), 9 /* TEXT, PROPS */, _hoisted_30))
                                    : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 64 /* STABLE_FRAGMENT */)),
                        (t.outcome !== 'expired' && ($setup.partsOf[t.id].endsFound.length + $setup.partsOf[t.id].endsMissed.length))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                              _createTextVNode(" Branch ends: " + _toDisplayString($setup.partsOf[t.id].endsFound.length) + " of " + _toDisplayString($setup.partsOf[t.id].endsFound.length + $setup.partsOf[t.id].endsMissed.length) + " marked, from " + _toDisplayString($setup.plural($setup.details[t.id].given.length, 'point')) + " placed", 1 /* TEXT */),
                              ($setup.details[t.id].stray)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(", " + _toDisplayString($setup.details[t.id].stray) + " of them near no end", 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(". ")
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_32, [
                          ($setup.details[t.id].end_root)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "nge-ttr-btn nge-ttr-btn--look",
                                onClick: $event => ($setup.reviewTryInView($setup.details[t.id]))
                              }, "Look at their cell", 8 /* PROPS */, _hoisted_33))
                            : (_openBlock(), _createElementBlock("span", _hoisted_34, "Their cell was not kept: cells are kept from Oct 21 on.")),
                          ($setup.details[t.id].end_root)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString($setup.details[t.id].end_root), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (t.outcome === null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_36, "Nothing to show until this try ends."))
                      : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}